import React, { Component } from 'react';
import Gravatar from 'react-gravatar';
import { Link } from 'react-router-dom';
import request from '../../../helpers/request';
import appConfig from '../../../config/appConfig';


export default class LoginInfo extends Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      name: '',
    };
  }

  componentDidMount() {
    request.get({
      url: appConfig.apiUrl + 'user/profile',
      success: profile => {
        this.setState(profile);
      }
    });
  }

  render() {
    return (
    <div className="login-info">
      <span>
        <Link to="/profile" active={true}>

          <Gravatar email={this.state.email} size={25} rating="pg" default="mm" https className="online" />
          <span>
              {this.state.name}
          </span>
        </Link>
      </span>
    </div>);
  }
}




// WEBPACK FOOTER //
// ./src/components/common/User/LoginInfo.js